import { withPrefix } from "gatsby"

export const isBrowser = () => typeof window !== "undefined"

export function redirect(to: string): void {
  if (isBrowser()) {
    window.location = (withPrefix(to) as unknown) as Location
  }
}
